import Paginator from "../../screens/group/Paginator.js";
export default class AggregationPaginator extends Paginator {
  get pages() {
    return 1;
  }
  get perPage() {
    return 1;
  }
  get page() {
    return 0;
  }
  get count() {
    return this.data.items.length;
  }
  get hasNextPage() {
    return false;
  }
  get hasPreviousPage() {
    return false;
  }
  setPage() {}
  setPerPage() {}
}